var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"colorff font14 foot"},[_c('p',[_vm._v(" Copyright ©2017-2021, All Rights Reserved ICP认证：粤A2-20100541 ")])])}]

export { render, staticRenderFns }